import { ButtonHTMLAttributes } from "react"
import { useTranslation } from "react-i18next"
import classNames from "classnames"

import Icon from "@/components/icon/Icon"
import { colors } from "@/components/colors"

import "./addComponentButton.scss"

export default function AddComponentButton({ ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  const { t } = useTranslation()

  return (
    <button {...props} className={classNames("report-setting-add-comp-btn", props.className)}>
      <Icon type="add" size={24} color={colors.neutral.grey[800]} />
      <p>{t("button.add")}</p>
    </button>
  )
}
